<template>
	<div class="page-container">
		<md-dialog-alert
		:md-active.sync="alert"
		:md-content="msgAlert"
		md-confirm-text="Ok" />
		<!-- MODAL SACAR/DEPOSITAR -->
		<div class="modal" v-bind:class="showDialogTransaction()">
			<div class="modal-background"></div>
			<div class="modal-content">
				<div class="card mx-3">
					<header class="card-header">
						<p class="card-header-title">
							Informe os dados para depósito/saque
						</p>
					</header>
					<div class="card-content">
						<div class="content">
							<div class="notification is-danger" v-if="valorError || chaveError">
								{{ msgErrorForm }}
							</div>
							<div class="field">
								<div class="control">
									<label class="label">Tipo de Transação</label>
									<label class="radio">
										<input type="radio" name="tipoTransacao" value="d" v-model.number="tipoTransacao">
										Depósito
									</label>
									<label class="radio">
										<input type="radio" name="tipoTransacao" value="s" v-model.number="tipoTransacao">
										Saque
									</label>
								</div>
							</div>
							<div class="field">
								<label class="label">Valor</label>
								<div class="control has-icons-left has-icons-right">
									<money class="input" v-bind:class="inputErrorClass(valorError)" type="text" placeholder="Valor" v-model="valor" v-bind="money" v-on:blur="verifyInputError(valor, 'valor')"></money>
									<span class="icon is-small is-left">
										<i class="fa-solid fa-brazilian-real-sign" v-bind:class="inputErrorClass(valorError)"></i>
									</span>
									<span class="icon is-small is-right" v-if="valorError">
										<i class="fa-solid fa-circle-exclamation" v-bind:class="inputErrorClass(valorError)"></i>
									</span>
								</div>
							</div>
							<div class="field" v-if="tipoTransacao == 's'">
								<label class="label">Tipo de chave</label>
								<div class="select" v-bind:class="inputErrorClass(tipoChave)">
									<select v-model="tipoChave">
										<option value="cpf">CPF</option>
										<option value="cnpj">CNPJ</option>
										<option value="tel">Telefone</option>
										<option value="email">E-mail</option>
										<option value="aleatoria">Aleatória</option>
									</select>
								</div>
							</div>
							<div class="field" v-if="tipoTransacao == 's'">
								<label class="label">Chave</label>
								<div class="control has-icons-left has-icons-right">
									<input class="input" v-bind:class="inputErrorClass(chaveError)" type="text" placeholder="Chave" v-model="chave" v-on:blur="verifyInputError(chave, 'chave')">
									<span class="icon is-small is-left">
										<i class="fa-solid fa-key" v-bind:class="inputErrorClass(chaveError)"></i>
									</span>
									<span class="icon is-small is-right" v-if="chaveError">
										<i class="fa-solid fa-circle-exclamation" v-bind:class="inputErrorClass(chaveError)"></i>
									</span>
								</div>
							</div>
						</div>
					</div>
					<footer class="modal-card-foot has-background-white	">
						<button v-bind:class="loadingClass()" class="button is-danger" v-on:click="dialogTransaction = false"><strong>FECHAR</strong></button>
						<button v-bind:class="loadingClass()" class="button is-link" v-on:click="confirmarTransacao()"><strong v-if="tipoTransacao == 'd'">CONFIRMAR</strong><strong v-if="tipoTransacao == 's'">SOLICITAR</strong></button>
					</footer>
				</div>
			</div>
			<button class="modal-close is-large" aria-label="close"></button>
		</div>
		<!-- FIM MODAL SACAR/DEPOSITAR -->
		<md-app md-mode="fixed">
			<md-app-toolbar class="md-primary">
				<md-button class="md-icon-button" @click="backHome()">
					<md-icon>arrow_back</md-icon>
				</md-button>
				<span class="md-title" style="font-size: 15px; font-weight: bold;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 240px; margin-left: 0;">
					Perfil
				</span>
			</md-app-toolbar>
			<md-app-content>
				<div class="fundo-geral" style="height: 100%;">
					<div class="columns is-mobile is-centered mt-2" v-if="cliente">
						<div class="column is-11">
							<div class="card">
								<div class="card-content">
									<div class="media">
										<div class="media-left">
											<span class="icon">
												<i class="fa-solid fa-user" style="font-size: 2em;"></i>
											</span>
										</div>
										<div class="media-content">
											<p class="title is-4">{{ cliente.name }}</p>
											<p class="subtitle is-6">{{ cliente.email }}</p>
											<p class="subtitle is-6">
												<div class="field mt-2">
													<span>Link parceiro</span>
													<p class="control has-icons-right"  @click="copyURL(partnerLink)">
														<input class="input" type="text" :value="partnerLink" readonly>
														<span class="icon is-medium is-right">
															<i class="fa-solid fa-copy"></i>
														</span>
													</p>
												</div>
											</p>
										</div>
									</div>

									<div class="content">
										<nav class="level">
											<div class="level-item has-text-centered">
												<div>
													<p class="heading">Saldo</p>
													<p class="title">{{ formataValor(cliente.balance) }}</p>
												</div>
											</div>
										</nav>
									</div>
								</div>
								<div class="columns is-centered is-mobile m-1">
									<div class="column">
										<button class="button is-success is-fullwidth" @click="dialogTransaction = true"><i class="fa-solid fa-money-bill-transfer mr-1"></i>Sacar/Depositar</button>
									</div>
								</div>
								<div class="columns is-centered is-mobile m-1">
									<div class="column">
										<button class="button is-link is-fullwidth" @click="goToStatement()"><i class="fa-solid fa-money-bill-transfer mr-1"></i> Extrato</button>
									</div>
								</div>
								<!-- <div class="columns is-centered is-mobile m-1">
									<div class="column">
										<button class="button is-warning is-fullwidth"><i class="fa-solid fa-users mr-1"></i>Afiliados</button>
									</div>
								</div> -->
								<div class="columns is-centered is-mobile m-1">
									<div class="column">
										<button class="button is-danger is-fullwidth" @click="logout()"><i class="fa-solid fa-right-from-bracket mr-1" ></i></i>Sair</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</md-app-content>
		</md-app>
	</div>
</template>
<script>

	import axios from 'axios'
	import { Money } from 'v-money'

	export default {
		name: 'TitanClient',
		components: {
			Money
		},
		data () {
			return {
				alert: false,
				msgAlert: '',
				loadingForm: false,
				dialogTransaction: false,
				valorError: null,
				chaveError: null,
				valor: 0,
				tipoTransacao: 'd',
				tipoChave: 'cpf',
				chave: '',
				money: {
					decimal: ',',
					thousands: '.',
					prefix: 'R$ ',
					precision: 2,
					masked: false
				}
			}
		},
		methods: {
			backHome: function() {
				this.$router.push({ name: 'TitanRoulette'})
			},
			goToStatement: function() {
				this.$router.push({ name: 'TitanClientStatement'})
			},
			loadingClass: function() {
				return {
					'is-loading': (this.loadingForm == true)
				}
			},
			showDialogTransaction: function() {
				return {
					'is-active': (this.dialogTransaction == true)
				}
			},
			formataValor: function(valor) {
				return parseFloat(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
			},
			verifyInputError: function(valor, campo) {
				if (campo == 'valor') {
					if (valor != '') this.valorError = false
					else this.valorError = true
				}

				if (this.tipoTransacao == 's') {
					if (campo == 'chave') {
						if (valor != '') this.chaveError = false
						else this.chaveError = true
					}
				}

				if (this.valorError || this.chaveError)
					this.msgErrorForm = 'Preencha corretamente os campos.';
			},
			inputErrorClass: function(campo) {
				return {
					'is-danger has-text-danger': (campo == true),
					'is-primary has-text-primary': (campo == false),
				}
			},
			logout: function() {
				this.$store.commit('LOGOUT_CLIENT');
				this.backHome();
			},
			confirmarTransacao: function() {
				if (this.cliente) {
					this.loadingForm = true;
					if (this.tipoTransacao == 'd') {
						var jsonDeposit = {};
						jsonDeposit.value = this.valor;

						var form = new FormData();
						form.append("data", JSON.stringify(jsonDeposit));

						var config = {
							headers: {'Content-Type': 'application/x-www-form-urlencoded', Authorization: 'Bearer  ' + this.$store.state.cliente.token}
						};

						var v = this;
						axios.post(this.$root.$data.API_URL + 'client/deposit', form, config)
						.then(function (response) {
					        // console.log(response);
							let result = response.data
							if (result.success && result.deposit) {
								v.$router.push({ name: 'TitanClientDeposit', params: { id: result.deposit }})
							} else {
								this.dialogTransaction = false;
								v.alert = true;
								v.msgAlert = result.message;
							}
						})
						.finally(() => v.loadingForm = false );
					}
					else {
						var jsonDeposit = {};
						jsonDeposit.value = this.valor;
						jsonDeposit.pix_key_type = this.tipoChave;
						jsonDeposit.pix_key = this.chave;

						var form = new FormData();
						form.append("data", JSON.stringify(jsonDeposit));

						var config = {
							headers: {'Content-Type': 'application/x-www-form-urlencoded', Authorization: 'Bearer  ' + this.$store.state.cliente.token}
						};

						var v = this;
						axios.post(this.$root.$data.API_URL + 'client/withdraw', form, config)
						.then(function (response) {
					        // console.log(response);
							let result = response.data
							if (result.success) {
								v.updateClientBalance(result.balance);
								v.tipoChave = 'cpf'
								v.chave = ''
								v.tipoTransacao = 'd'
								v.valor = 0
								v.dialogTransaction = false
								v.msgErrorForm = ''
								v.chaveError = null
								v.valorError = null
								v.alert = true
								v.msgAlert = 'Seu saque foi solicitado com sucesso. Aguarde enquanto processamos sua solicitação.'
							} else {
								if (result.invalid_key) {
									v.msgErrorForm = result.message;
									v.chaveError = true;
								}
								else {
									v.msgErrorForm = result.message;
									v.valorError = true;
								}
							}
						})
						.finally(() => v.loadingForm = false );
					}
				}
				else {
					this.dialogTransaction = false;
					this.alert = true;
					this.msgAlert = 'Ocorreu um problema com seu login, por favor recarregue a página.';
				}
			},
			async copyURL(textToCopy) {
			    // navigator clipboard api needs a secure context (https)
				if (navigator.clipboard && window.isSecureContext) {
			        // navigator clipboard api method'
					await navigator.clipboard.writeText(textToCopy);

					alert('Copiado!');
				} else {
			        // text area method
					let textArea = document.createElement("textarea");
					textArea.value = textToCopy;
			        // make the textarea out of viewport
					textArea.style.position = "fixed";
					textArea.style.left = "-999999px";
					textArea.style.top = "-999999px";
					document.body.appendChild(textArea);
					textArea.focus();
					textArea.select();
					return new Promise((res, rej) => {
			            // here the magic happens
						document.execCommand('copy') ? res() : rej();
						textArea.remove();

						alert('Copiado!');
					});
				}
			},
			updateClientBalance: function(balance) {
				this.$store.state.cliente.balance = balance
			}
		},
		created() {
			if (!this.cliente) this.backHome();
		},
		mounted() {},
		computed: {
			cliente: function () {
				return this.$store.state.cliente
			},
			partnerLink: function () {
				return this.$root.$data.URL + '#/client-register/' + this.cliente.id
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "~vue-material/dist/theme/engine"; // Import the theme engine

	@include md-register-theme("default", (
		primary: #000000, // The primary color of your brand
		accent: #CB1323 // The secondary color of your brand
		));

	@import "~vue-material/dist/theme/all"; // Apply the theme

	.md-app-scroller {
		overflow: unset;
	}

</style>


// WEBPACK FOOTER //
// src/components/TitanClient.vue